// QueryStatus.js
import React from 'react';
import {
  Box,
  Typography
} from '@mui/material';

const QueryStatus = ({ 
  status, 
  status_verbose, 
  size = 'small',
  sx = {}
}) => {
  // Query status configuration with colors - customer queries and website messages
  const getStatusColor = (status) => {
    const colors = {
      // Customer Query Statuses
      'Approved': '#28a745', // Success - Green
      'Pending': '#ffc107', // Warning - Orange
      'Rejected': '#dc3545', // Error - Red
      'Hold': '#17a2b8', // Info - Blue
      'Processed': '#007bff', // Primary - Blue
      
      // Website Message Statuses
      'Pending Response': '#ffc107', // Warning - Orange
      'In Progress': '#17a2b8', // Info - Blue
      'Acknowledged': '#007bff', // Primary - Blue
      'Resolved': '#28a745', // Success - Green
      'Closed': '#6c757d', // Secondary - Gray
      'Spam': '#dc3545' // Error - Red
    };
    return colors[status] || '#6c757d'; // Default gray for unknown status
  };

  const statusColor = getStatusColor(status_verbose || status);

  return (
    <Box 
      sx={{ 
        display: 'inline-block',
        px: 1.5,
        py: 0.5,
        borderRadius: 1,
        backgroundColor: `${statusColor}20`, // 20% opacity background
        border: `1px solid ${statusColor}`,
        ...sx
      }}
    >
      <Typography 
        variant={size === 'small' ? 'body2' : 'body1'}
        sx={{ 
          fontWeight: 600,
          fontSize: size === 'small' ? '0.75rem' : '0.875rem',
          color: statusColor,
          textAlign: 'center'
        }}
      >
        {status_verbose || status || 'Unknown'}
      </Typography>
    </Box>
  );
};

export default QueryStatus; 